import { $, Iterator } from '@starberry/components';

export default {
  $: 'Stack',

  template: {
    $: 'Stack',
    props: {
      direction: 'column',
      spacing: 7,
    },
    children: [
      {
        $: 'ActionableListItem',
        data: (_, context) => context.data,
        time: $('value'),
        props: {
          mb: 3,
        },
      },
    ],
  },

  children: (props) => [
    !props.hideTitle && { $: 'SectionHeading', title: 'Activity', props: { mb: 3 } },
    {
      $: 'Stack',
      spacing: 5,
      children: [
        {
          component: Iterator,
          provide: ['activity'],
          props: {
            data: 'state.activity.0.activitiesData',
            limit: props.limit || 5,
            template: props.template,
          },
        },
      ],
    },
  ],
};
